// Service Worker Registration for React App (TypeScript)
// This file handles registering and managing the service worker

interface Config {
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
  }
  
  const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );
  
  export function register(config?: Config): void {
    if ('serviceWorker' in navigator) {
      const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
      if (publicUrl.origin !== window.location.origin) {
        return;
      }
  
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
  
        if (isLocalhost) {
          // This is running on localhost
          checkValidServiceWorker(swUrl, config);
          navigator.serviceWorker.ready.then(() => {
            console.log('This web app is being served cache-first by a service worker.');
          });
        } else {
          // Is not localhost. Register service worker
          registerValidSW(swUrl, config);
        }
      });
    }
  }
  
  function registerValidSW(swUrl: string, config?: Config): void {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration: ServiceWorkerRegistration) => {
        console.log('SW registered successfully');
        
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the updated precached content has been fetched,
                // but the previous service worker will still serve the older
                // content until all client tabs are closed.
                console.log('New content is available and will be used when all tabs for this page are closed.');
                
                // Execute callback
                if (config?.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {
                // At this point, everything has been precached.
                console.log('Content is cached for offline use.');
                
                // Execute callback
                if (config?.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          };
        };
      })
      .catch((error: Error) => {
        console.error('Error during service worker registration:', error);
      });
  }
  
  function checkValidServiceWorker(swUrl: string, config?: Config): void {
    // Check if the service worker can be found
    fetch(swUrl, {
      headers: { 'Service-Worker': 'script' },
    })
      .then((response: Response) => {
        const contentType = response.headers.get('content-type');
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          // No service worker found
          navigator.serviceWorker.ready.then((registration: ServiceWorkerRegistration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });
        } else {
          // Service worker found. Proceed as normal.
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log('No internet connection found. App is running in offline mode.');
      });
  }
  
  export function unregister(): void {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration: ServiceWorkerRegistration) => {
          registration.unregister();
        })
        .catch((error: Error) => {
          console.error(error.message);
        });
    }
  }
  
  // Helper function to update the service worker
  export function updateServiceWorker(): void {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration: ServiceWorkerRegistration) => {
        if (registration.waiting) {
          // Tell the service worker to skip waiting and become active
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      });
    }
  }